import { Result } from "../search-spring/types/types";

export const transformShopifyProduct = (shopifyProduct: any): Result => {
  const result: Result = {
    brand: shopifyProduct.vendor || '',
    collection_handle: extractCollectionHandles(shopifyProduct.tags),
    handle: shopifyProduct.handle || '',
    id: shopifyProduct.id?.toString() || '',
    image: shopifyProduct.featured_image || '',
    images: shopifyProduct.images || [],
    imageUrl: shopifyProduct.featured_image || '',
    intellisuggestData: '',
    intellisuggestSignature: '',
    mfield_custom_product_bi_line: '',
    mfield_my_fields_alternate_colours: [],
    mfield_my_fields_metal: extractMetalFromTags(shopifyProduct.tags),
    msrp: shopifyProduct.compare_at_price?.toString() || '',
    name: shopifyProduct.title || '',
    price: (shopifyProduct.price / 100).toString(),
    product_type_unigram: shopifyProduct.type || '',
    sku: shopifyProduct.variants?.[0]?.sku || '',
    ss_available: shopifyProduct.available?.toString() || 'false',
    ss_collection_exclude: 'false',
    ss_has_image: (!!shopifyProduct.featured_image).toString(),
    ss_images: shopifyProduct.images || [],
    ss_image: shopifyProduct.featured_image || '',
    ss_image_hover: shopifyProduct.images[1] ?? undefined,
    ss_inventory_count: calculateTotalInventory(shopifyProduct.variants).toString(),
    ss_is_samepair: 'false',
    ss_search_exclude: 'false',
    ss_tags: shopifyProduct.tags || [],
    template_suffix: '',
    thumbnailImageUrl: shopifyProduct.featured_image || '',
    uid: shopifyProduct.id?.toString() || '',
    url: `/products/${shopifyProduct.handle}`,
    variant_price: (shopifyProduct.price / 100).toString(),
    variant_title: getVariantTitle(shopifyProduct.variants?.[0]),
  };

  if (shopifyProduct.images && shopifyProduct.images.length > 1) {
    result.ss_image_hover = shopifyProduct.images[1];
  }

  if (shopifyProduct.tags) {
    result.tags_badge = extractBadgeTags(shopifyProduct.tags);
  }

  if (shopifyProduct.compare_at_price) {
    result.variant_compare_at_price = (shopifyProduct.compare_at_price / 100).toString();
  }

  const priceRange = getPriceRange(shopifyProduct);
  if (priceRange.length > 0) {
    result.ss_price_range = priceRange;
  }

  return result;
}

const extractCollectionHandles = (tags: string[]): string[] => {
  if (!tags) return [];
  return tags
    .filter(tag => tag.startsWith('Collection_'))
    .map(tag => tag.replace('Collection_', '').toLowerCase());
}

const extractMetalFromTags = (tags: string[]): string => {
  if (!tags) return '';
  const metalTags = tags.filter(tag => 
    tag.includes('Gold') || tag.includes('Silver') || tag.includes('Platinum')
  );
  return metalTags[0] || '';
}

const calculateTotalInventory =(variants: any[]): number => {
  if (!variants) return 0;
  return variants.reduce((total, variant) => {
    return total + (variant.inventory_quantity || 0);
  }, 0);
}

const getVariantTitle = (variant: any): string => {
  if (!variant) return '';
  const options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
  return options.join(' / ');
}

const extractBadgeTags = (tags: string[]): string[] => {
  if (!tags) return [];
  // TODO: show badges without prefix badge_
  // return tags.filter(tag => tag.startsWith('badge_'));
  return [];
}

const getPriceRange = (shopifyProduct: any): string[] => {
  if (!shopifyProduct.variants || shopifyProduct.variants.length === 0) return [];
  
  const prices = shopifyProduct.variants.map((variant: any) => variant.price / 100);
  const minPrice = Math.min(...prices);
  const maxPrice = Math.max(...prices);
  
  if (minPrice === maxPrice) {
    return [minPrice.toString()];
  }
  
  return [minPrice.toString(), maxPrice.toString()];
}
